import { FinancialAccount } from '/@/modules/financialaccount/models/FinancialAccount';
import { FinancialAccountType } from '/@/modules/financialaccount/constants/FiancialAccountType';
import { LoanAndCreditPaymentAccountType } from '/@/modules/liability/enums/LoanAndCreditPaymentAccountType';
import { LiabilityType } from '@/modules/liability/enums/LiabilityType';
import { FinancialInstitution } from '@/modules/predefined/models/FinancialInstitution';
import { Asset } from '@/modules/asset/models/Asset';

// eslint-disable-next-line @typescript-eslint/typedef, @typescript-eslint/no-explicit-any
export const LiabilityFormMixin: unknown = (superClass: any) =>
  class extends superClass {
    setFinancialInstitution(value: FinancialInstitution): void {
      if (!this.financialAccount) {
        this.financialAccount = FinancialAccount.mapModel();
        this.financialAccount.type = FinancialAccountType.LOAN;
      }
      this.financialAccount.financialInstitutionId = value.id;
      this.financialAccount.financialInstitution = value;
    }

    setAsset(value: Asset): void {
      this.asset = value;
    }

    resetAsset(): void {
      this.assetId = null;
    }

    get accountName(): string {
      const { financialAccount } = this;
      return [
        LoanAndCreditPaymentAccountType.MORTGAGE.key,
        LoanAndCreditPaymentAccountType.HOME_EQUITY.key,
        LoanAndCreditPaymentAccountType.AUTO.key
      ].includes(financialAccount.subType)
        ? this.asset.name
        : financialAccount.name;
    }

    get descriptiveTitle(): string {
      switch (this.type) {
        case LiabilityType.LOAN_AND_CREDIT_PAYMENT.key:
          return `${this.financialAccount?.financialInstitution?.name} - ${
            this.financialAccount?.name
          } - ${LoanAndCreditPaymentAccountType.getByKey(this.financialAccount?.subType)?.value}`;
        default:
          return '';
      }
    }
  };
